import { useTranslation } from 'react-i18next';
import { FieldError, Flex, TextField } from '@/components/common';
import { SimpleTextFieldProps } from '../common/RadixProps';

export interface HeightFieldProps extends Omit<SimpleTextFieldProps, 'onChange'> {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  error?: string;
}

export function HeightField({ value, onChange, error, ...rest }: HeightFieldProps) {
  const { t } = useTranslation('onboarding');

  return (
    <Flex direction="column" gap="1">
      <TextField.Root
        {...rest}
        style={{ flexGrow: 1 }}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        maxLength={3}
        placeholder={t('steps.height.placeholder')}
        aria-label={t('steps.height.fieldLabel')}
        aria-invalid={error ? true : undefined}
        value={value != null ? String(value) : ''}
        onChange={e => {
          const trimmed = e.target.value.trim();
          const parsed = trimmed === '' ? undefined : Number.parseInt(trimmed, 10);
          onChange(Number.isNaN(parsed) ? undefined : parsed);
        }}
      />
      <FieldError message={error} />
    </Flex>
  );
}
